export default {"src":"/_next/static/media/GroupChat.1e813d05.svg","height":10,"width":16,"blurWidth":0,"blurHeight":0};